<template>
  <footer class="cobalt-bg-color">
    <div
      class="mt-1 ml-10 flex flex-col sm:flex-row sm:flex-wrap sm:mt-0 sm:space-x-10"
    >
      <!-- <div
        class="mt-2 flex items-center text-sm text-gray-300"
        v-if="token == ''"
      >
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          ></path>
        </svg>
        <router-link
          to="/login"
          class="my-3 block text-gray-300 hover:text-white text-sm font-medium duration-700"
        >
          Register/Login
        </router-link>
      </div>
      <div
        class="mt-2 flex items-center text-sm text-gray-300"
        v-if="agent_user?.id">
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <router-link
              to="/commission_report" class="my-3 block text-gray-300 hover:text-white text-sm font-medium duration-700">
                    Commission Report
                  </router-link>
      </div>
      <div
        class="mt-2 flex items-center text-sm text-gray-300"
        v-if="agent_user?.id">
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>               
                  <router-link
          to="/membership_report" class="my-3 block text-gray-300 hover:text-white text-sm font-medium duration-700">
                    Membership Report
                  </router-link>
      </div>
      <div
        class="mt-2 flex items-center text-sm text-gray-300"
        v-if="agent_user?.id">
        <svg
          class="flex-shrink-0 mr-1.5 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
                  <router-link
          to="/company_statistics_report" class="my-3 block text-gray-300 hover:text-white text-sm font-medium duration-700">
                    Company Statistics Report
                  </router-link>
      </div> -->
      <!-- <div
        class="pb-5 px-8 pt-5 border-gray-500 text-[#1f3341] text-sm">
        Have questions about your Agent Portal? Email us at webmaster@uslegalservices.net
      </div> -->
    </div>
    <div class="">
      <div
        class="flex pb-5 xl:ml-16 lg:ml-8 sm:ml-6 ml-4 pt-5 
            border-gray-500 text-[#1f3341] text-sm 
            flex-col md:flex-row max-w-6xl"
      >
        <div>
           © 2016 - {{ currentYear }} U.S. Legal Services. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "Footer",
  computed: mapState(["token","agent_user"]),
  data() {
  return {
    currentYear: new Date().getFullYear()
  };
}
};
</script>
